import { NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, ViewEncapsulation, computed, inject } from '@angular/core';
import { GlobalConfig } from '@partners/kernel';
import { ShellStore } from '@partners/state';
import { FADE_IN_OUT_ANIMATION, ProgressBarComponent } from '@partners/ui';
import { calcPercent } from '@partners/utils';

@Component({
  selector: 'application-progress',
  standalone: true,
  imports: [NgIf, ProgressBarComponent],
  template: `<ng-container *ngIf="!isHidden$$()">
    <div class="title" [@fadeInOut]>{{ headerCaption$$() }}</div>
    <progress-bar mode="relative" [value]="value$$()" [initialValue]="10" [@fadeInOut]></progress-bar
  ></ng-container>`,
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  animations: [FADE_IN_OUT_ANIMATION]
})
export class ApplicationProgressComponent {
  private _shellStore = inject(ShellStore);
  private _globalConfig = inject(GlobalConfig);

  /** header caption placed above progress bar */
  headerCaption$$ = this._globalConfig.fromText$$('headerCaption');

  /**
   * in some cases, as the main content changes, we want to hide the progress bar. for example -
   * in screens which are loaded and displayed but are not part of the sale process, such as
   * error pages, guide pages, summary page etc', we use isHidden to toggle the display of the
   * app progress bar as specified in the current view's settings
   */
  isHidden$$ = computed<boolean>(() => {
    const { isProgressHidden } = this._shellStore.viewSettings$$();
    return isProgressHidden;
  });

  value$$ = computed<number>(() => {
    const total = this._shellStore.totalStages$$();
    const totalComplete = this._shellStore.totalCompleteStages$$();
    const percentValue = calcPercent(totalComplete, total);
    return percentValue;
  });
}
